export function roundRect(ctx, x, y, width, height, radius, fill, stroke) {
	if (typeof stroke === 'undefined') {
		stroke = true;
	}
	if (typeof radius === 'undefined') {
		radius = 5;
	}
	if (typeof radius === 'number') {
		radius = { tl: radius, tr: radius, br: radius, bl: radius };
	} else {
		const defaultRadius = { tl: 0, tr: 0, br: 0, bl: 0 };
		for (let side in defaultRadius) {
			radius[side] = radius[side] || defaultRadius[side];
		}
	}
	ctx.beginPath();
	ctx.moveTo(x + radius.tl, y);
	ctx.lineTo(x + width - radius.tr, y);
	ctx.quadraticCurveTo(x + width, y, x + width, y + radius.tr);
	ctx.lineTo(x + width, y + height - radius.br);
	ctx.quadraticCurveTo(x + width, y + height, x + width - radius.br, y + height);
	ctx.lineTo(x + radius.bl, y + height);
	ctx.quadraticCurveTo(x, y + height, x, y + height - radius.bl);
	ctx.lineTo(x, y + radius.tl);
	ctx.quadraticCurveTo(x, y, x + radius.tl, y);
	ctx.closePath();
	if (fill) {
		if (fill === 'transparent') {
			ctx.fillStyle = 'transparent';
		}
		ctx.fill();
	}
	if (stroke) {
		ctx.strokeStyle = stroke;
		ctx.stroke();
	}
}

/* ---------------------------------------------------------- 
* Check if mouse event (pos) is inside the control box (area).
 ----------------------------------------------------------*/
export function isInside(pos, area) {
	return (pos.x >= area.x - 5 && pos.x <= area.x + 5)
		&& (pos.y >= area.y - 5 && pos.y <= area.y + 5);
}

//getEventPosition() returns position of mouse event relative to ssg-canvas element -----------------
// see canvas.js getTouchPos() for touch version.
export function getEventPosition(event) {

	const rect = event.currentTarget.getBoundingClientRect();
	const eventX = event.touches ? event.touches[0].clientX : event.clientX;
	const eventY = event.touches ? event.touches[0].clientY : event.clientY;

	return {
		x: eventX - rect.left - rect.width / 2,
		y: eventY - rect.top - rect.height / 2
	};
}


/*---- allInside() returns true if all vertices are within (and not intersecting) coverage rectangle.--------*/
export function allInside(vertices, coverage) {

	const box = {
		top: coverage.y,
		bottom: coverage.y + coverage.height,
		left: coverage.x,
		right: coverage.x + coverage.width
	};

	return vertices[0].y > box.top
		&& vertices[1].y > box.top
		&& vertices[2].y > box.top
		&& vertices[3].y > box.top
		&& vertices[0].x > box.left
		&& vertices[1].x > box.left
		&& vertices[2].x > box.left
		&& vertices[3].x > box.left
		&& vertices[0].x < box.right
		&& vertices[1].x < box.right
		&& vertices[2].x < box.right
		&& vertices[3].x < box.right
		&& vertices[0].y < box.bottom
		&& vertices[1].y < box.bottom
		&& vertices[2].y < box.bottom
		&& vertices[3].y < box.bottom;
}

/***********
NOTE:
This line intersection method (anyLineIntersect) works correctly.
So we can work towards removal of method (linesIntersect)
because it doesn't give the correct results in every case
***********/
export function anyLineIntersect(vertices, coverage) {
	const imageLines = verticesToLines(vertices);

	let cx = coverage.x;    // coverage position (topLeft point basically)
	let cy = coverage.y;
	let cw = coverage.width;    // and size
	let ch = coverage.height;

	let lines_intersect = []; //Array to maintain intersection result of all lines

	for(let i=0; i<imageLines.length; i++) {
		let x1 = imageLines[i].p1.x;
		let y1 = imageLines[i].p1.y;
		let x2 = imageLines[i].p2.x;
		let y2 = imageLines[i].p2.y;

		lines_intersect.push(lineRect(x1,y1,x2,y2,  cx,cy,cw,ch));
	}

	if(lines_intersect.includes(true)) { //If any intersection is true
		return true;
	}
	else {
		return false;
	}
}

function lineRect(x1,y1,x2,y2,  rx,ry,rw,rh) {

	// check if the line has hit any of the rectangle's sides
	// uses the Line/Line function below
	let left = lineLine(x1,y1,x2,y2,  rx,ry,rx,ry+rh);
	let right = lineLine(x1,y1,x2,y2,  rx+rw, ry,rx + rw,ry+rh);
	let top = lineLine(x1,y1,x2,y2,  rx,ry,rx+rw,ry);
	let bottom = lineLine(x1,y1,x2,y2,  rx,ry+rh,rx+rw,ry+rh);

	// if ANY of the above are true, the line
	// has hit the rectangle
	if (left || right || top || bottom) {
		return true;
	}
	return false;
}

function lineLine(x1, y1, x2, y2, x3, y3, x4, y4) {

	// calculate the direction of the lines
	let uA = ((x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3)) / ((y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1));
	let uB = ((x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3)) / ((y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1));

	// if uA and uB are between 0-1, lines are colliding
	if (uA >= 0 && uA <= 1 && uB >= 0 && uB <= 1) {
		return true;
	}
	return false;
}


//check if atleast 1 point is inside the template sides
export function verticeOverlap(vertices, bleedBox) {
	return (vertices[0].y > bleedBox.top
		&& vertices[0].y < bleedBox.bottom
		&& vertices[0].x > bleedBox.left
		&& vertices[0].x < bleedBox.right)
		||
		(vertices[1].y > bleedBox.top
			&& vertices[1].y < bleedBox.bottom
			&& vertices[1].x > bleedBox.left
			&& vertices[1].x < bleedBox.right)
		||
		(vertices[2].y > bleedBox.top
			&& vertices[2].y < bleedBox.bottom
			&& vertices[2].x > bleedBox.left
			&& vertices[2].x < bleedBox.right)
		||
		(vertices[3].y > bleedBox.top
			&& vertices[3].y < bleedBox.bottom
			&& vertices[3].x > bleedBox.left
			&& vertices[3].x < bleedBox.right);
}

export function linesIntersect(vertices, bleedBox) {
	const imageLines = verticesToLines(vertices);

	const templateLines = verticesToLines([
		{ x: Math.round(bleedBox.left), y: Math.round(bleedBox.bottom) },
		{ x: Math.round(bleedBox.left), y: Math.round(bleedBox.top) },
		{ x: Math.round(bleedBox.right), y: Math.round(bleedBox.top) },
		{ x: Math.round(bleedBox.right), y: Math.round(bleedBox.bottom) }
	]);

	for (let i = 0; i < imageLines.length; i++) {
		for (let j = 0; j < templateLines.length; j++) {
			
			if (lineIntersect(

				Math.round(imageLines[i].p1.x),
				Math.round(imageLines[i].p1.y),
				Math.round(imageLines[i].p2.x),
				Math.round(imageLines[i].p2.y),
				templateLines[j].p1.x,
				templateLines[j].p1.y,
				templateLines[j].p2.x,
				templateLines[j].p2.y

			)
			) {
				return true;
			}
		}
	}

	return false;
}

function verticesToLines(vertices) {
	const lines = [];

	for (let i = 0; i < vertices.length; i++) {
		let next = i + 1;
		if (next === vertices.length) {
			next = 0;
		}
		lines.push({ p1: vertices[i], p2: vertices[next] });
	}

	return lines;
}

//check if boundary of image intersects boundary of bleed area
function lineIntersect(x1, y1, x2, y2, x3, y3, x4, y4) {
	const x = ((x1 * y2 - y1 * x2) * (x3 - x4) - (x1 - x2) * (x3 * y4 - y3 * x4)) / ((x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4));
	const y = ((x1 * y2 - y1 * x2) * (y3 - y4) - (y1 - y2) * (x3 * y4 - y3 * x4)) / ((x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4));

	//console.log('intersect (' + x1 + ',' + y1 + ')' + '(' + x2 + ',' + y2 + ')' + '(' + x3 + ',' + y3 + ')' + '(' + x4 + ',' + y4 + ')' );

	/*if (isNaN(x) || isNaN(y)) {
		return false;
	} else {*/
	if (x1 >= x2) {
		if (!(x2 <= x && x <= x1)) {
			return false;
		}
	} else {
		if (!(x1 <= x && x <= x2)) {
			return false;
		}
	}
	if (y1 >= y2) {
		if (!(y2 <= y && y <= y1)) {
			return false;
		}
	} else {
		if (!(y1 <= y && y <= y2)) {
			return false;
		}
	}
	if (x3 >= x4) {
		if (!(x4 <= x && x <= x3)) {
			return false;
		}
	} else {
		if (!(x3 <= x && x <= x4)) {
			return false;
		}
	}
	if (y3 >= y4) {
		if (!(y4 <= y && y <= y3)) {
			return false;
		}
	} else {
		if (!(y3 <= y && y <= y4)) {
			return false;
		}
	}
	/*}*/
	return true;
}


/**
 * Helper function to determine whether there is an intersection between the two polygons described
 * by the lists of vertices. Uses the Separating Axis Theorem
 *
 * @param a an array of connected points [{x:, y:}, {x:, y:},...] that form a closed polygon
 * @param b an array of connected points [{x:, y:}, {x:, y:},...] that form a closed polygon
 * @return true if there is any intersection between the 2 polygons, false otherwise
 */
export function doPolygonsIntersect(a, b) {
	let polygons = [a, b];
	let minA, maxA, projected, i, i1, j, minB, maxB;

	for (i = 0; i < polygons.length; i++) {

		// for each polygon, look at each edge of the polygon, and determine if it separates
		// the two shapes
		let polygon = polygons[i];
		for (i1 = 0; i1 < polygon.length; i1++) {

			// grab 2 vertices to create an edge
			let i2 = (i1 + 1) % polygon.length;
			let p1 = polygon[i1];
			let p2 = polygon[i2];

			// find the line perpendicular to this edge
			let normal = { x: p2.y - p1.y, y: p1.x - p2.x };

			minA = maxA = undefined;
			// for each vertex in the first shape, project it onto the line perpendicular to the edge
			// and keep track of the min and max of these values
			for (j = 0; j < a.length; j++) {
				projected = normal.x * a[j].x + normal.y * a[j].y;
				if (isUndefined(minA) || projected < minA) {
					minA = projected;
				}
				if (isUndefined(maxA) || projected > maxA) {
					maxA = projected;
				}
			}

			// for each vertex in the second shape, project it onto the line perpendicular to the edge
			// and keep track of the min and max of these values
			minB = maxB = undefined;
			for (j = 0; j < b.length; j++) {
				projected = normal.x * b[j].x + normal.y * b[j].y;
				if (isUndefined(minB) || projected < minB) {
					minB = projected;
				}
				if (isUndefined(maxB) || projected > maxB) {
					maxB = projected;
				}
			}

			// if there is no overlap between the projects, the edge we are looking at separates the two
			// polygons, and we know there is no overlap
			if (maxA < minB || maxB < minA) {
				console.log("polygons don't intersect!");
				return false;
			}
		}
	}
	return true;
}

function isUndefined(val) {
	return val === undefined;
}



export function hexToRgb(hex) {
	// Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
	const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
	hex = hex.replace(shorthandRegex, function (m, r, g, b) {
		return r + r + g + g + b + b;
	});

	const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	return result ? {
		r: parseInt(result[1], 16),
		g: parseInt(result[2], 16),
		b: parseInt(result[3], 16)
	} : null;
}


/* Function to check wheather any diagonal lines of signature or bleedBox intersect each other */
export function diagonalIntersect(diagonal_vertices, bleedBox) {
	let imageLines = verticesToLines(diagonal_vertices);
	
	let coverageLines = verticesToLines([
		{ x: Math.round(bleedBox.left), y: Math.round(bleedBox.bottom) },
		{ x: Math.round(bleedBox.right), y: Math.round(bleedBox.top) },
		{ x: Math.round(bleedBox.left), y: Math.round(bleedBox.top) },
		{ x: Math.round(bleedBox.right), y: Math.round(bleedBox.bottom) }
	]);
	
	const removeItem = (items, i) =>
	items.slice(0, i-1).concat(items.slice(i, items.length));

	let diagonalImageLines = removeItem(imageLines, 2)
	diagonalImageLines = removeItem(diagonalImageLines, 3);

	let diagonalCoverageLines = removeItem(coverageLines, 2)
	diagonalCoverageLines = removeItem(diagonalCoverageLines, 3);

	let diagonals_intersect = []; //Array to maintain intersection result of all lines

	for(let i=0; i<diagonalImageLines.length; i++) {
		for(let j=0; j<diagonalCoverageLines.length; j++) {
			let ix1 = diagonalImageLines[i].p1.x;
			let iy1 = diagonalImageLines[i].p1.y;
			let ix2 = diagonalImageLines[i].p2.x;
			let iy2 = diagonalImageLines[i].p2.y;
			
			let cx1 = diagonalCoverageLines[j].p1.x;
			let cy1 = diagonalCoverageLines[j].p1.y;
			let cx2 = diagonalCoverageLines[j].p2.x;
			let cy2 = diagonalCoverageLines[j].p2.y;

			diagonals_intersect.push(lineLine(ix1,iy1,ix2,iy2,  cx1,cy1,cx2,cy2));
		}
	}

	if(diagonals_intersect.includes(true)) { //If any intersection is true
		return true;
	}
	else {
		return false;
	}
}


/* Function to show warning if user has resized the signature to be very small (only in Metal) */
export function isSmallSignature(image_data, coverage) {
	// ( width_sign * height_sign < 65% * width_area * height_area) 

	let sign_w = image_data.width;
	let sign_h = image_data.height;

	let coverage_w = coverage.width;
	let coverage_h = coverage.height;

	if((sign_w * sign_h) < ((coverage_w * coverage_h) / 6.5)) {
		return true;
	}
	else {
		return false;
	}
}
